<template>
  <v-layout justify-center class="white">
    <v-flex xs12 sm10 md10 justify-center>
      <v-layout>
        <v-flex xm12 sm4 class="title text-xs-center text-sm-left align-center">
        </v-flex>
        <v-flex xm12 md4 class="text-sm-center">
          <span class="headline">Photos</span><br />
          <span>(Click image to view full size)</span><br />
        </v-flex>
      </v-layout>

      <v-card>
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <v-flex
              v-for="(item, index) in rows"
              :key="index"
              md4
              d-flex
            >
              <v-card>
                <v-img
                  :src="item.filePath"
                  aspect-ratio="1"
                  class="grey lighten-2"
                  @click="theImage(item.filePath)"
                >
                  <template v-slot:placeholder>
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
                </v-img>

                <v-card-title primary-title>
                  <div>
                    <h3 class="mb-0">Kangaroo Valley Safari</h3>
                    <div> test </div>
                  </div>
                </v-card-title>

                <v-card-actions>
                  <v-btn v-if="item.active === 'Yes'" flat color="orange" @click="showStatus(item, 'No')">Don't Show</v-btn>
                  <v-btn v-else flat color="green" @click="showStatus(item, 'Yes')">Show</v-btn>
                  <v-divider></v-divider>
                  <v-btn flat color="red" @click="deletePhoto(item.id)">Delete</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="newItem()">Add</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>

    <v-dialog
      v-model="viewDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
      persistent
    >
    <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <img max-width="250" :src="viewImage" alt="Company image" />
    </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
      persistent
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Photo</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="save">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-text-field
                  label="Select..."
                  @click='onPickFile'
                  v-model='fileName'
                  prepend-icon="attach_file"
                ></v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="fileInput"
                  accept="image/*"
                  @change="onFilePicked">
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'

export default {
  props: ['item', 'currentYear'],

  data () {
    return {
      myId: this.$store.state.user.id,
      page: 'Photos',
      dialog: false,
      viewDialog: false,
      viewImage: null,
      loading: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      height: 0,
      rows: [],
      files: [],
      fileName: ''
    }
  },

  created () {
    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getPhotos()

    this.loading = false
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize () {
      const height = window.innerHeight - 600
      this.height = height + 'px'
    },

    onPickFile () {
      this.$refs.fileInput.click()
    },

    onFilePicked (event) {
      const files = event.target.files
      if (files[0] !== undefined) {
        this.fileName = files[0].name
        // Check validity of file
        if (this.fileName.lastIndexOf('.') <= 0) {
          return
        }
        // If valid, continue
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.url = fr.result
          this.fileObject = files[0] // this is an file that can be sent to server...
        })
      } else {
        this.fileName = ''
        this.fileObject = null
        this.url = ''
      }
    },

    newItem () {
      this.dialog = true
    },

    theImage (image) {
      this.viewImage = image
      this.viewDialog = true
    },

    async getPhotos () {
      try {
        const response = await Api().get('vendor_photos/' + this.item.id)

        this.rows = response.data
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async showStatus (item, status) {
      try {
        const response = await Api().put('vendor_photos/' + item.id, item)

        item.active = status

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.error = error.response.data.error
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async save () {
      let filenames = []

      let formData = new FormData()
      formData.append('year', this.currentYear)
      formData.append('fileName', this.fileName)
      formData.append('active', 'Yes')
      formData.append('VendorCompanyId', this.item.id)

      for (var i = 0; i < this.files.length; i++) {
        formData.append('files', this.files[i])
        filenames.push(this.files[i].name)
      }

      formData.append('files', this.fileObject)

      try {
        const response = await Api().post('vendor_photos', formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

        this.editDocument = []
        this.getPhotos()
        this.dialog = false

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async deletePhoto (id) {
      let r = confirm('Are you sure you want to remove this photo?')

      if (r === true) {
        try {
          const response = await Api().delete('vendor_photos/' + id)

          this.getPhotos()

          this.snackbar.message = response.data.message
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } catch (error) {
          this.snackbar.message = error.response.data.error
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      }
    },

    close () {
      this.editDocument = {}

      this.dialog = false
      this.viewDialog = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.vgt-fixed-header {
  z-index: 1;
}

.vgt-fixed-header th:last-child {
    /* Offset for the scrollbar, you may have to adjust this */
    width: calc(100% + 17px) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/vendor/PhotoList.vue